<template>
  <div>
    <p>
      <span class="speedee-bold mr-4">Last Updated:</span>
      <span class="mr-4" style="color: #03c04a">{{ lastUpdated == "" || lastUpdated == null ? 'No Latest Update' :
        lastUpdated }}</span>
      <span v-show="lastUpdated != null">
        <i class="ml-1 fa fa-light fa-check-circle-o" style="color: #03c04a"></i>
      </span>
    </p>

    <TableComponent :columns="tableColumns" :tableData="tableData" :rows="5">
      <template #filterButtons>
        <div class="btn-group mb-2 mr-2" role="group" v-for="(button, index) in buttons" :key="index">
          <Primary :index="index"
            :buttonClass="[button.status ? 'btn-warning' : 'bg-light-dark', button.status ? 'text-dark' : 'text-grey']"
            @click="handleButtonClick(button.id)">{{ button.name }}</Primary>
        </div>
      </template>
      <Column headerStyle="color: white; background-color: black" field="description" header="Description">
        <template #body="slotProps">
          <span>{{ sanitizedContent(slotProps.data.description) }}</span>
        </template>
      </Column>
      <Column headerStyle="color: white; background-color: black" field="author" header="Author & Date/Time"></Column>
      <Column headerStyle="color: white; background-color: black" field="approved_by" header="Approved by & Date/Time">
      </Column>
      <Column headerStyle="color: white; background-color: black" field="statusText" header="Status">
        <template #body="slotProps">
          <span :class="[getClass(slotProps.data.status), blockStatus(slotProps.data.status), 'btn btn-block']">{{
            slotProps.data.statusText }}</span>
        </template>
      </Column>
      <Column headerStyle="color: white; background-color: black" field="remarks">
        <template #header="{ header }">
          {{ 'Remarks' }}

          <span class="ml-2">
            <i class="pi pi-info-circle" aria-hidden="true" v-tooltip.top="textTooltip"></i>
          </span>
        </template>
      </Column>
    </TableComponent>
  </div>
</template>

<script>
import TableComponent from '@/components/TableComponent';
import Primary from '@/components/PrimaryButton';
import Tooltip from 'primevue/tooltip';

export default {
  inheritAttrs: false,

  directives: {
    'tooltip': Tooltip
  },

  components: {
    TableComponent,
    Primary
  },

  props: {
    tableData: {
      Type: Array,
      required: true,
      default: []
    },

    tableColumns: {
      Type: Array,
      required: true,
      default: []
    },

    buttons: {
      Type: Array,
      required: false,
      default: []
    },

    getClass: {
      type: Function,
      required: true,
    },

    blockStatus: {
      type: Function,
      required: true,
    },

    textTooltip: {
      type: String,
      required: false,
      default: 'String'
    },

    lastUpdated: {
      type: String,
      required: true,
    }
  },

  data() {
    return {
      type: 'buttons'
    }
  },

  methods: {
    handleButtonClick(index) {
      this.$emit('click', this.type, index)
    },

    sanitizedContent(strTxt) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(strTxt, 'text/html');

      return doc.body.textContent;
    }
  },
}
</script>